"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_gefahr_schwierigbefahrbar = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_gefahr_schwierigbefahrbar = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACaSURBVFhHYxiKwJKbm9vSwMCAF8RxcHBgExUVtQSJAzEbSIwUwASlSQHHoFgHzGNgEANimBiITRIgxwFUBaMOGHXAqANGHTDqgFEHjDpg1AGjDhh1wKgDRh1AsgOYmJgYGBkZoTzKATOUJhrw8/Nf4+TkXM3Ly3vmxYsX3zMzMzkUFRVtdHR0nhgZGS09d+7cV6jSUUAEYGAAAPksFK93EHglAAAAAElFTkSuQmCC",
    iconSize: [32, 32],
});
